import { BooleanConditionSchema } from '@framework/engine/inputs/expressions-editor/conditions/BooleanConditionSchema.ts';
import { RichTextAdvancedSchema } from '@framework/engine/inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { ReferenceSchema } from '@framework/engine/schema/expressions/validation/ReferenceSchema.ts';
import { BaseLayoutSchema } from '@framework/engine/schema/widgets/repository/common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { hideLabelConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/HideLabelConfigInput.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { UploadWidgetAgidConfigSchema } from '#features/packages/xsd-web/src/widgets/agid-upload/UploadWidgetAgidConfigSchema.ts';
import {
  type IUploadWidget,
  UploadButtonsLayout,
  UploadWidgetKind,
  WidgetUploadType,
} from './IUploadWidget.ts';

export const uploadInputConfigSchema: yup.ObjectSchema<IUploadWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetUploadType).required(),
    kind: yup
      .string()
      .oneOfEnum(UploadWidgetKind)
      .default(UploadWidgetKind.Button)
      .required()
      .label('Tipo'),
    title: RichTextAdvancedSchema.label('Titolo').optional(),
    publicUploadTitle: RichTextAdvancedSchema
      // Rimuovo il campo se l'omissis è disabilitato
      .when(
        ['directives.omissis.enabled'],
        ([omissisEnabled]: boolean[], schema) => {
          if (omissisEnabled) return schema;
          return schema.strip();
        },
      )
      .default([])
      .optional()
      .label('Titolo documento pubblico'),
    publicHelpText: RichTextAdvancedSchema
      // Rimuovo il campo se l'omissis è disabilitato
      .when(
        ['directives.omissis.enabled'],
        ([omissisEnabled]: boolean[], schema) => {
          if (omissisEnabled) return schema;
          return schema.strip();
        },
      )
      .optional()
      .default([])
      .label('Testo di aiuto documento pubblico'),
    publicUploadLabel: RichTextAdvancedSchema
      // Rimuovo il campo se l'omissis è disabilitato
      .when(
        ['directives.omissis.enabled'],
        ([omissisEnabled]: boolean[], schema) => {
          if (omissisEnabled) return schema;
          return schema.strip();
        },
      )
      .optional()
      .default([])
      .label('Etichetta documento pubblico'),
    layout: BaseLayoutSchema.shape({
      hideLabel: hideLabelConfigSchema,
      buttonLayout: yup
        .string()
        .oneOfEnum(UploadButtonsLayout)
        .default(UploadButtonsLayout.Vertical)
        .optional()
        .label('Posizionamento pulsanti'),
    })
      .required()
      .noUnknown(),
    // Regole di visibilità
    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
    defaultValueReference: ReferenceSchema.notRequired().label(
      'Documento predefinito',
    ),

    ...UploadWidgetAgidConfigSchema,
  })
    .required()
    .noUnknown();

function agidAttachmentCondition(
  isAgidAttachment: boolean[],
  schema: yup.AnySchema,
) {
  if (isAgidAttachment[0]) return schema.required();
  return schema.notRequired().strip();
}
